import HipotekaMap from '../components/hipoteka/hipotekaMap'
export default {
  computed: {
    bylaTipasList() {
      return {
        rinkmena: {
          title: this.byla.byl_pavadinimas,
          icon: 'mdi-file-outline',
          fileName: this.byla.byl_pavadinimas,
        },
        download: {
          title: this.byla.byl_rusis,
          icon: 'mdi-file-download-outline',
          fileName: this.byla.byl_pavadinimas,
        },
        savitarna_pran: {
          title: 'Pranešimas registrui',
          icon: 'mdi-file-check-outline',
          fileName: `Pranešimas registrui`,
        },
        savitarna_dok: {
          title: `${this.dokumentasTipas}${this.dokumentasNumeris}`,
          icon: 'mdi-file-document-outline',
          fileName: `${this.dokumentasTipas}${this.dokumentasNumeris}`,
        },
        preview_pran: {
          title: 'Pranešimas registrui (peržiūra)',
          icon: 'mdi-file-check-outline',
          fileName: `Pranešimas registrui (peržiūra)`,
        },
        preview_dok: {
          title: `${this.dokumentasTipas}${this.dokumentasNumeris} (peržiūra)`,
          icon: 'mdi-file-document-outline',
          fileName: `${this.dokumentasTipas}${this.dokumentasNumeris} (perziura)`,
        },
        preview_word: {
          title: `${this.dokumentasTipas}${this.dokumentasNumeris} (word)`,
          icon: 'mdi-file-word-outline',
          fileName: `${this.dokumentasTipas}${this.dokumentasNumeris} (perziura).doc`,
        },
        pranesimas: {
          title: 'Pranešimas registrui',
          icon: 'mdi-file-check-outline',
          fileName: `Pranešimas registrui${this.pranesimasNumeris}`,
        },
        dokumentas: {
          title: `${this.dokumentasTipas}${this.dokumentasNumeris}`,
          icon: 'mdi-file-document-outline',
          fileName: `${this.dokumentasTipas}${this.dokumentasNumeris}`,
        },
        siunciami_paieska: {
          title: `Registro pranesimas${this.pranesimasNumeris}`,
          icon: 'mdi-file-check-outline',
          fileName: `Registro pranesimas${this.pranesimasNumeris}`,
        },
        siunciami: {
          title: 'Registro pranešimas',
          icon: 'mdi-file-check-outline',
          fileName: `Registro pranesimas${this.pranesimasNumeris}`,
        },
        paieska_issamus: {
          title: this.byla.byl_pavadinimas,
          icon: 'mdi-file-document-outline',
          fileName: this.byla.byl_pavadinimas,
        },
        paieska_turinys_issamus: {
          title: this.byla.byl_pavadinimas,
          icon: 'mdi-file-document-outline',
          fileName: this.byla.byl_pavadinimas,
        },
        paieska_archyvas: {
          title: this.byla.byl_pavadinimas,
          icon: 'mdi-file-document-outline',
          fileName: this.byla.byl_pavadinimas,
        },
        paieska_turinys_archyvas: {
          title: this.byla.byl_pavadinimas,
          icon: 'mdi-file-document-outline',
          fileName: this.byla.byl_pavadinimas,
        },
        ataskaita_pdf: {
          title: this.byla.byl_pavadinimas,
          icon: 'mdi-file-chart-outline',
          fileName: `${this.byla.byl_pavadinimas}.${this.byla.ext}`,
        },
        ataskaita_docx: {
          title: this.byla.byl_pavadinimas,
          icon: 'mdi-file-word-outline',
          fileName: `${this.byla.byl_pavadinimas}.${this.byla.ext}`,
        },
        ataskaita_xlsx: {
          title: this.byla.byl_pavadinimas,
          icon: 'mdi-file-excel-outline',
          fileName: `${this.byla.byl_pavadinimas}.${this.byla.ext}`,
        },
        archyvas: {
          title: `${this.byla.byl_rusis}, ${this.byla.byl_dokumento_data}`,
          icon: 'mdi-file-chart-outline',
          fileName: `${this.byla.byl_pavadinimas}`,
        },
        pagrindas: {
          title: this.byla.byl_pavadinimas,
          icon: 'mdi-file-outline',
          fileName: `${this.byla.byl_pavadinimas}`,
        },
        regitra: {
          title: this.byla.byl_pavadinimas,
          icon: 'mdi-file-outline',
          fileName: `${this.byla.byl_pavadinimas}`,
        },
        preview_ntr: {
          title: this.byla.byl_rusis,
          icon: 'mdi-file-document-outline',
          fileName: this.byla.byl_pavadinimas,
        },
        ntr_israsas: {
          title: this.byla.byl_rusis,
          icon: 'mdi-file-download',
          fileName: this.byla.byl_pavadinimas,
        },
        ntr_pra_rink: {
          title: this.byla.byl_pavadinimas,
          icon: 'mdi-file-download-outline',
          fileName: this.byla.byl_pavadinimas,
        },
        ntr_pra_gen: {
          title: this.byla.byl_pavadinimas,
          icon: 'mdi-file-document-outline',
          fileName: this.byla.byl_pavadinimas,
        },
        naikinimo_aktas: {
          title: this.byla.byl_pavadinimas,
          icon: 'mdi-file-word-outline',
          fileName: this.byla.byl_pavadinimas,
        },
        naikinimo_zip: {
          title: this.byla.byl_pavadinimas,
          icon: 'mdi-folder-zip-outline',
          fileName: this.byla.byl_pavadinimas,
        },
      }
    },
    objTipas() {
      return this.byla.obj_tipas ?? ''
    },
    isSutartis() {
      return this.objTipas.includes('sutartis')
    },
    dokumentasTipas() {
      return HipotekaMap['hipotekaTipas'][this.objTipas]
        ? HipotekaMap['hipotekaTipas'][this.objTipas].title
        : this.objTipas
    },
    bylaTipas() {
      const key = Object.keys(this.bylaTipasList).find(
        e => this.byla.byl_tipas && this.byla.byl_tipas.includes(e)
      )
      return this.bylaTipasList[key] ?? this.bylaTipasList.rinkmena
    },
    bylaIcon() {
      return this.bylaTipas.icon ?? 'mdi-file-outline'
    },
    bylaTitle() {
      return this.bylaTipas.title
    },
    bylaIconTitle() {
      return this.byla.icon_title ?? this.bylaTitle
    },
    dokumentasNumeris() {
      return this.byla.obj_dokumento_numeris
        ? ` Nr. ${this.byla.obj_dokumento_numeris}`
        : ''
    },
    pranesimasNumeris() {
      return this.byla.pranesimas_numeris
        ? ` ${this.byla.pranesimas_numeris}`
        : ''
    },
    bylaName() {
      return this.byla.byl_sugeneruota &&
        this.byla.byl_tipas !== 'preview_word' &&
        this.byla.byl_tipas !== 'regitra' &&
        this.byla.byl_tipas !== 'ataskaita_pdf' &&
        this.byla.byl_tipas !== 'ataskaita_docx' &&
        this.byla.byl_tipas !== 'ataskaita_xlsx'
        ? `${this.bylaTipas.fileName}${
            this.bylaTipas.fileName
              .split('.')
              .pop()
              .toLowerCase() === 'pdf'
              ? ''
              : '.pdf'
          }`
        : this.bylaTipas.fileName
    },
  },
}
